import { Link } from "react-router-dom";
import VenuefyMark from "./VenuefyMark";

/** Wedding-site brand: the official Venuefy mark tinted with the event's
 *  motif colors (brand rule: purple on venuefy.com, theme colors on event sites). */
export default function Brand({ small = false }) {
  return (
    <Link to="/riyazandaimee" className="inline-flex items-center gap-3 group" data-testid="brand-link">
      <VenuefyMark
        size={small ? 30 : 38}
        left="var(--motif-text, #2b2b2b)"
        right="var(--motif-primary, #c2a14d)"
        bars="var(--motif-primary, #c2a14d)"
      />
      <div className="leading-tight">
        <div className={`font-display ${small ? "text-lg" : "text-xl"} text-motif`}>Venuefy</div>
        {!small && <div className="text-[10px] text-motif-muted tracking-luxe">the event os</div>}
      </div>
    </Link>
  );
}
